/**
 * The clock every frame is measured against.
 *
 * Owned by the engine and handed to scenes through the {@link EngineContext}, so two engines can run
 * side by side with independent clocks and a test can step time by hand.
 */
export class Time {
  #deltaSeconds = 0;
  #elapsedSeconds = 0;
  #frameCount = 0;

  /** Seconds since the previous frame, already clamped by the loop. */
  get deltaSeconds(): number {
    return this.#deltaSeconds;
  }

  /** Seconds of running time since the clock was last reset, excluding time spent paused. */
  get elapsedSeconds(): number {
    return this.#elapsedSeconds;
  }

  /** Frames completed since the clock was last reset. */
  get frameCount(): number {
    return this.#frameCount;
  }

  /** @internal Advances the clock by one frame. Called by the engine only. */
  advance(deltaSeconds: number): void {
    this.#deltaSeconds = deltaSeconds;
    this.#elapsedSeconds += deltaSeconds;
    this.#frameCount += 1;
  }

  /** @internal Returns the clock to its initial state. Called by the engine only. */
  reset(): void {
    this.#deltaSeconds = 0;
    this.#elapsedSeconds = 0;
    this.#frameCount = 0;
  }
}
